import React from 'react';
import NewTabLink from './NewTabLink';
import { AnchorProps } from '@sls-react/components/Links/A';

type Props = AnchorProps & {
  page?: string;
};

const BlogLink: React.FC<Props> = ({ children, page, ...props }) => (
  <NewTabLink href={`/blog${page || ''}`} {...props}>
    {children}
  </NewTabLink>
);

export default BlogLink;
